import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import type { OrderStatusType } from "@models/order";
import { STATUS_META } from "./status";

interface StatusBadgeProps {
    status: OrderStatusType;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
    const meta = STATUS_META[status] ?? {
        label: String(status),
        color: ComponentColor.Ghost,
    };

    return (
        <Badge color={meta.color} size={ComponentSize.SM}>
            {meta.label}
        </Badge>
    );
};
